document.addEventListener("DOMContentLoaded", function (event) {
  setTimeout(() => {
    gsap.registerPlugin(ScrollTrigger);
    gsap.registerPlugin(ScrollToPlugin);

    const pinnedMenu = document.querySelector("#pinned-menu");
    const links = pinnedMenu.querySelectorAll(".pinnedLink");
    const sections = document.querySelectorAll(".scrollSection");

    if (window.innerWidth >= 1320) {
      ScrollTrigger.create({
        trigger: pinnedMenu,
        start: `top 50px`,
        end: `${pinnedMenu.parentElement.clientHeight - 50}px 489px`,
        markers: false,
        pin: true,
      });

      sections.forEach((section, index) => {
        let linkActive;
        links.forEach((link) => {
          if (`#${section.getAttribute("id")}` === link.getAttribute("href")) linkActive = link;
        });
        console.dir(linkActive);
        ScrollTrigger.create({
          trigger: section,
          id: index + 1,
          start: "top center",
          end: () => `+=${section.clientHeight}`,
          toggleActions: "play reverse none reverse",
          toggleClass: { targets: linkActive, className: `${linkActive.classList[0]}_active` },
          markers: false,
        });
      });
    }

    function scrollToSection(e) {
      e.preventDefault();

      const target = document.querySelector(`${e.target.getAttribute("href")}`);

      gsap.to(window, {
        duration: 1,
        scrollTo: target,
        ease: "power2",
      });
    }

    links.forEach((link) => {
      link.addEventListener("click", scrollToSection);
    });
  }, 100);
});
